import React from 'react';
import { Typography } from 'antd';
import { useSpeciesLifecycleOptional } from './SpeciesLifecycleContext';
import { getLifecycleTierName, normalizeSpeciesSlug } from './core';

const { Text } = Typography;

/**
 * Display name for one lifecycle tier (e.g. young → "Lamb").
 * Pass `profiles` when rendering outside SpeciesLifecycleProvider.
 */
export default function SpeciesLifecycleTierName({
  speciesSlug,
  category,
  tier,
  profiles: profilesProp,
  fallback = '—',
  ...textProps
}) {
  const lifecycle = useSpeciesLifecycleOptional();
  const profiles = profilesProp ?? lifecycle?.profiles;
  const slug = normalizeSpeciesSlug(speciesSlug ?? category);
  const name = slug && tier ? getLifecycleTierName(profiles, slug, tier) : null;

  return <Text {...textProps}>{name || fallback}</Text>;
}
